<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="eligibleCampaign" class="bg-content" data-testid="gamification-home-page">
    <div style="max-width: 480px" class="relative z-10">
      <BlNavBarMv
        class="absolute top-0 w-full"
        has-back-button
        background-color="none"
        action-text="Panduan"
        data-testid="navbar"
        @handleBackButtonClick="onClickBack"
        @handleClickActionText="onClickPanduan"
      />
    </div>
    <div class="w-full relative" style="height: 250px">
      <img :src="bannerImg" alt="gamification-banner" class="w-full object-cover rounded-b-3xl" style="height: 250px" />
    </div>
    <div class="ph-24 relative z-10 content-height" style="margin-top: -64px">
      <BlTextAv variation="caption-12" weight="medium" class="mb-20 text-center" data-testid="periode-text">{{ periodeText }}</BlTextAv>
      <div class="bg-white rounded-2xl ph-12 pv-16 mb-20" data-testid="campaign-details">
        <div class="flex justify-between items-baseline">
          <div>
            <BlTextAv color="subdued" variation="caption-12">Total Progress</BlTextAv>
            <BlTextAv weight="bold" variation="body-14" class="mt-4">{{ totalTransaction }}</BlTextAv>
          </div>
          <div class="flex items-center">
            <BlButtonAv variation="link" has-icon-right @click="onUpdateShowModal(true)">
              Lihat kelas kamu
              <IcoChevronRightMinor slot="icon" color="#2B4AC7" />
            </BlButtonAv>
          </div>
        </div>
        <PrakerjaProgressBar :check-point-item="checkPointItem" />
        <GamificationNoticeMessage :missions="missions" />
        <BlSeparatorAv />
        <div class="mv-16">
          <BlTextAv weight="bold" variation="caption-12">Hadiah yang bisa kamu ambil</BlTextAv>
          <div class="flex gap-4 items-center flex-col mt-12">
            <GamificationCard v-for="(mission, idx) in missions" :key="idx" :idx="idx" :mission="mission" data-testid="gamification-card" />
          </div>
        </div>
        <BlSeparatorAv />
        <div class="mv-16">
          <BlTextAv weight="bold" variation="caption-12">Belajar sambil ikut misi, makin untung ✨</BlTextAv>
          <div class="mt-12 flex gap-4 items-center">
            <img :src="$publicUrl('images/kartu-prakerja/gift-icon.webp')" alt="gift-icon" loading="lazy" width="36" height="36" />
            <BlTextAv variation="caption-12">Kumpulin hadiah hingga jutaan</BlTextAv>
          </div>
          <div class="mt-8 flex gap-4 items-center">
            <img :src="$publicUrl('images/kartu-prakerja/money-icon.webp')" alt="money-icon" loading="lazy" width="36" height="36" />
            <BlTextAv variation="caption-12">Hadiah bisa diklaim setelah kelas selesai</BlTextAv>
          </div>
        </div>
      </div>
    </div>
    <div class="sticky bottom-0 z-10">
      <div class="flex rounded-t-2xl bg-[#D2E7F6] items-center justify-between p-16">
        <BlButtonAv class="btn-lihat-kelas-lain" data-testid="btn-lihat-kelas-lain" fullwidth @click="onClickShowKelasLain">
          Lihat Kelas Lain
        </BlButtonAv>
      </div>
    </div>
    <PrakerjaGamificationTransactionList
      v-if="eligibleCampaignId"
      :is-show-transaction="isShowTransaction"
      :eligible-campaign-id="eligibleCampaignId"
      @onUpdateShowModal="onUpdateShowModal"
    />
  </div>
</template>

<script>
import {optimizeImageWidth} from 'shared_js/image-helpers';
import {BlButtonAv, BlTextAv, BlSeparatorAv, BlNavBarMv} from '@bukalapak/bazaar-mweb-latest';
import {IcoChevronRightMinor} from '@bukalapak/bazaar-visual-next';
import PrakerjaProgressBar from 'shared/components/PrakerjaProgressBar/PrakerjaProgressBar';
import GamificationCard from '../components/GamificationCard/GamificationCard.vue';
import GamificationNoticeMessage from '../components/GamificationNoticeMessage/GamificationNoticeMessage.vue';
import {money} from '@bukalapak/toolbox-helper/number-helper';
import moment from 'moment';
import {mapGetters} from 'vuex';
import PrakerjaGamificationTransactionList from '../components/PrakerjaGamificationTransactionList/PrakerjaGamificationTransactionList.vue';
moment.locale('id');
import {TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_PAGE} from '../config/tracker-events';
import trackerGenerator from '../mixins/tracker-generator';

export default {
  name: 'PrakerjaGamificationHomePage',
  components: {
    BlButtonAv,
    PrakerjaProgressBar,
    BlTextAv,
    IcoChevronRightMinor,
    BlSeparatorAv,
    GamificationCard,
    BlNavBarMv,
    GamificationNoticeMessage,
    PrakerjaGamificationTransactionList,
  },
  filters: {money},
  mixins: [trackerGenerator],
  data() {
    return {
      eligibleCampaign: null,
      isShowTransaction: false,
    };
  },
  computed: {
    ...mapGetters(['getPreviousPage']),
    missions() {
      return this.eligibleCampaign?.missions || [];
    },
    isTransactionAmountType() {
      return this.eligibleCampaign?.missions?.[0]?.goal_type === 'transaction_amount';
    },
    totalTransaction() {
      const total = this.missions?.reduce((acc, mission) => acc + (mission?.milestone?.progress || 0), 0);
      return this.isTransactionAmountType ? money(total) : total;
    },
    checkPointItem() {
      const listCheckPoint = [{percentage: 0, text: 'Mulai!', used_quota: 0, quota: 0}];
      this.missions?.forEach((mission) => {
        listCheckPoint.push({
          percentage: Math.floor(((mission?.milestone?.progress || 0) / mission?.goal_threshold) * 100),
          text: mission.reward_description,
          used_quota: mission.used_quota,
          quota: mission.quota,
        });
      });
      return listCheckPoint;
    },
    bannerImg() {
      return this.eligibleCampaign?.banner_url || this.$publicUrl('images/kartu-prakerja/gamification-banner.png');
    },
    periodeText() {
      const startDate = moment(this.eligibleCampaign?.period_start).format('DD MMMM');
      const endDate = moment(this.eligibleCampaign?.period_end).format('DD MMMM YYYY');
      return `Periode ${startDate} - ${endDate}`;
    },
    isLoggedIn() {
      return !!window.USER?.id;
    },
    eligibleCampaignId() {
      return this.eligibleCampaign?.id;
    },
  },
  beforeMount() {
    if (!this.isLoggedIn) {
      const {isAndroid, isWebview} = window.USER?.agent ?? {};
      const prefixHost = isAndroid || !isWebview ? window.location.origin : '';
      const encodedComebackUrl = window.encodeURIComponent(`${prefixHost}${process.env.BASE_PATH}/gamification`);
      window.location.replace(`${prefixHost}/login?comeback=${encodedComebackUrl}`);
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    optimizeImageWidth,
    async init() {
      try {
        const response = await this.$api.getPrakerjaGamificationEligibleCampaign();
        if (!response.data || response.data?.state !== 'active') {
          this.$router.replace({path: '/'});
          return;
        }
        this.eligibleCampaign = response.data;
        this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_PAGE, {
          source: 'gamification_home_page',
          action: 'impress_gamification_homepage',
        });
      } catch (error) {
        this.$router.replace({path: '/'});
      }
    },
    onClickBack() {
      const previousDomain = document.referrer ? new URL(document.referrer)?.hostname : '';
      const currentDomain = window.location.hostname;

      if (previousDomain === currentDomain || this.getPreviousPage?.name) {
        this.$router.go(-1);
      } else {
        this.$router.push({name: 'landing'});
      }
    },
    onClickPanduan() {
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_PAGE, {
        source: 'gamification_home_page',
        action: 'click_gamification_panduan',
      });
      window.location.href = 'https://blog.bukalapak.com/prakerja/syarat-dan-ketentuan-kompetisi-buka-bukaan-prakerja-di-bukalapak-123610';
    },
    onUpdateShowModal(value) {
      this.isShowTransaction = value;
    },
    onClickShowKelasLain() {
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_PAGE, {
        source: 'gamification_home_page',
        action: 'click_gamification_pilihan_kelas',
      });
      this.$router.push({
        name: 'closest-course',
        from: 'prakerja-gamification-home',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-content {
  background: linear-gradient(177.81deg, #006ad3 1.84%, #479fec 42.86%, #1269a7 86.41%);
  &::v-deep {
    .bl-nav-bar {
      z-index: 100;
      .bl-nav-bar__item-action-set {
        cursor: pointer;
      }
      svg path {
        fill: #2e2e2e;
      }
    }
  }
}
.content-height {
  min-height: calc(100vh - 252px - 32px);
}

.btn-lihat-kelas-lain {
  background: #332f9e;
  border-radius: 100px;
  border: 2px solid #332f9e;
}
.btn-lihat-kelas-lain:active {
  background: #4743c9;
  border-color: #4743c9;
}
.btn-lihat-kelas-lain:hover {
  background: #4743c9;
  border-color: #4743c9;
}
</style>
